import { request } from './http'

export interface Foreshadow {
  id: string
  project_id: string
  title: string
  content: string
  status: string
  plant_chapter_number: number | null
  target_resolve_chapter_number: number | null
  actual_resolve_chapter_number: number | null
  is_long_term: boolean
}

interface ForeshadowListResponse {
  foreshadows: Foreshadow[] | null
}

/**
 * 标为长线伏笔并把回收章节推到后面。
 *
 * 卷末硬门(foreshadow_volume_gate)拦下时给的提示就是
 * 「请在本卷内回收，或标记为长线伏笔并把回收章节推到后面的卷」——
 * 在此之前这个操作只有后端接口、界面里没有入口，用户只剩「重写赌模型」
 * 或「要求关掉这道门」两条路。一道拦得准却没有出口的门等价于假失效。
 */
export const foreshadowApi = {
  reschedulePending: (projectId: string, chapterNo: number, branchId: string): Promise<import('../components/chapters/ForeshadowDebtContract').DebtContract> =>
    request(`/v1/projects/${encodeURIComponent(projectId)}/outlines/${chapterNo}/reschedule-foreshadows?branch_id=${encodeURIComponent(branchId)}`, {method: 'POST', body: {}}),
  decide: (projectId: string, id: string, branchId: string, body: {target_resolve_chapter_number?: number; is_long_term?: boolean}): Promise<Foreshadow> =>
    request(`/v1/projects/${encodeURIComponent(projectId)}/foreshadows/${encodeURIComponent(id)}?branch_id=${encodeURIComponent(branchId)}`, {method: 'PATCH', body}),
  remove: (projectId: string, id: string, branchId: string): Promise<void> =>
    request(`/v1/projects/${encodeURIComponent(projectId)}/foreshadows/${encodeURIComponent(id)}?branch_id=${encodeURIComponent(branchId)}`, {method: 'DELETE'}),
  list: async (projectId: string): Promise<Foreshadow[]> => {
    const data = await request<ForeshadowListResponse>(
      `/v1/projects/${encodeURIComponent(projectId)}/foreshadows`,
    )
    return data.foreshadows ?? []
  },

  markLongTerm: (projectId: string, foreshadowId: string, resolveChapter: number): Promise<Foreshadow> =>
    request<Foreshadow>(
      `/v1/projects/${encodeURIComponent(projectId)}/foreshadows/${encodeURIComponent(foreshadowId)}`,
      {
        method: 'PUT',
        body: { is_long_term: true, target_resolve_chapter_number: resolveChapter },
      },
    ),
}
